import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { searchCMS } from "../../../redux/actions/search";
import CMSSearchResults from "./CMSSearchResults";

import styles from '../../../styles/Components/CMSSearchResults.module.css';

const CMSSearchBar = ({
    searchCMS,
    cmsSearch: { cmsSearchResults }
}) => {
    const searchRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('')
    const [viewingSuggestion, setViewingSuggestion] = useState(false);
    const [searching, setSearching] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [searchNow, setSearchNow] = useState(false);
    const [clearingSearchNow, setClearingSearchNow] = useState(false);

    let timeout
    const handleSearch = (term, searchNow) => {
        
        if (noResults) {
            setNoResults(false)
        }

        if (term?.length > 1) {
            setSearching(true)

            if (searchNow) {
                searchCMS(term, 10)

                setClearingSearchNow(true)
                setSearchNow(false)

            } else {
                timeout = setTimeout(() => {
                    searchCMS(term, 10)
                }, 1000)

            }
        } else if (!term && cmsSearchResults && Object.entries(cmsSearchResults).length > 0) {
            searchCMS('')
        }

        if (!term && viewingSuggestion) {
            setViewingSuggestion(false)
        }
    }

    const handleChange = (e) => {
        const { value } = e.target;

        if (viewingSuggestion && !value.startsWith('SUGGESTION: ')) {
            return
        }

        const newSearchTerm = viewingSuggestion ? value.replace('SUGGESTION: ', '') : value

        setSearchTerm(newSearchTerm)
    }

    useEffect(() => {

        if (clearingSearchNow) {
            setClearingSearchNow(false)
        } else {
            handleSearch(searchTerm, searchNow)
        }

        return () => clearTimeout(timeout)
    }, [searchTerm, searchNow])

    useEffect(() => {
        if (searching) {
            if (cmsSearchResults && !(Object.values(cmsSearchResults).find(resultArray => resultArray?.length > 0))) {
                setNoResults(true)
            }

            setSearching(false)
        }

    }, [cmsSearchResults])

    return (
        <div className={styles.search_container}>
            <input 
                ref={searchRef}
                type="text" 
                placeholder={'Search Content on the CMS'} 
                className={styles.search_header_input} 
                onChange={(e) => handleChange(e)} 
                value={`${viewingSuggestion ? 'SUGGESTION: ' : ''}${searchTerm}`}
                onKeyDown={(e) => e.key === 'Enter' ? setSearchNow(true) : ''}

            />

            {viewingSuggestion ? 
                <button className={styles.search_clear_button} onClick={() => setSearchTerm('')}>Clear</button>
            : null}

            <CMSSearchResults 
                searchTerm={searchTerm} 
                setSearchTerm={setSearchTerm} 
                viewingSuggestion={viewingSuggestion} 
                setViewingSuggestion={setViewingSuggestion}
                searchRef={searchRef}
                searching={searching}
                noResults={noResults}
            />
        </div>
    )
}


const mapStateToProps = (state) => ({
    cmsSearch: state.cmsSearch
});

export default connect(mapStateToProps, {
    searchCMS,
})(CMSSearchBar);
